import axios from 'axios'
import {
  requestHandler,
  responseHandler,
  responseErrorHandler
} from 'services/Instances/utils'

import { ApiType, getAxiosConfiguration, errorHandler } from './configuration'

const axiosConfiguration = getAxiosConfiguration(ApiType.Read)
const readApiClient = axios.create(axiosConfiguration)

readApiClient.interceptors.request.use(requestHandler, errorHandler)
readApiClient.interceptors.response.use(responseHandler, responseErrorHandler)

export { readApiClient }
